import { HideWrapper } from "@portal/BaseComponents/HideWrapper/HideWrapper";
import { AmountWithCurrencySplit } from "@portal/BaseComponents/MultiCurrency/AmountWithCurrencySplit";
import { SnapShotTile } from "@portal/BaseComponents/SnapShotTile/SnapShotTile";
import { TileProps } from "../type";

function InDisputeTile(props: TileProps) {
  const { loading, data } = props;
  return (
    <HideWrapper hide={false}>
      <SnapShotTile
        direction="row"
        size="md"
        align="center"
        justify="space-between"
        heading={{ text: "In Dispute", fs: "14", color: "var(--gray-8)" }}
        loading={loading}
        bottomStrip={{ color: "var(--orange-2)" }}
        count={{
          title: { value: "Invoices", fs: "12" },
          fs: "12",
          value: data?.disputed_invoices_amount.invoice_count ?? 0,
          align: "start",
          width: "auto",
        }}
        headerWidth="auto"
        amount={
          data ? (
            <AmountWithCurrencySplit
              type="multi"
              amountWithCurrencySplit={data.disputed_invoices_amount.amount}
              style={{ fontSize: "16px", fontWeight: "var(--fs-semibold)" }}
            />
          ) : undefined
        }
      />
    </HideWrapper>
  );
}

export { InDisputeTile };
